import {LabelWithoutJson} from '@/components/atoms'
import './_sectionTitle.scss'
import {FONT_SIZE, FONT_WEIGHT} from '@/utils/constants/globalStyle'
import {COLOR_CODE} from '@/utils/constants/colors'
/**
 * SectionTitle component renders a header section with a label.
 *
 * @param {Object} props - The component props.
 * @param {string} props.label - The text to display in the header.
 * @param {string} props.fontSize - The font size to use for the label.
 * @returns {JSX.Element} The rendered SectionTitle component.
 */
const SectionTitle = ({
  id,
  label,
  isBorderVisible = false,
  fontSize = FONT_SIZE.MD,
  color = COLOR_CODE._EFEFEF,
  className,
}) => {
  const containerClass = className || 'w-full pb-3 pt-5'
  return (
    <div className={`${isBorderVisible && 'sc-border'} ${containerClass}`}>
      <LabelWithoutJson
        id={`${id}_section_header`}
        text={label}
        fontWeight={FONT_WEIGHT.BOLD}
        fontSize={fontSize}
        color={color}
      />
    </div>
  )
}
export default SectionTitle
